<template>
  <div class="forgot-form">
    <transition name="fade" appear mode="out-in">

      <div v-if="showStep === 'form'" :key="transitionKey">
        <h2 class="text-campton-bold">{{ $gettext('Reset your password') }}</h2>
        <b-form @submit.prevent="saveNewPassword" class="gk-clear-form">

          <b-form-group id="fieldset-new-password" class="form-group floating-label">
            <div class="position-relative">
              <b-form-input
                type="password"
                id="input-new-password"
                placeholder=" "
                class="floating-label" :class="{ 'is-touch': passwordTouch }"
                v-model="password"
                :state="passwordState"
                trim required
                @blur="passwordTouch = true"
              />
              <label class="floating-label">{{ $gettext('New password') }}</label>
              <ShowPasswordIcon input-id="input-new-password" />
            </div>
            <PasswordStrengthHint v-if="showPasswordHint" :password="password" @score-changed="(score) => { passwordScore = score }" />
          </b-form-group>

          <b-form-group id="fieldset-repeat-password" class="form-group floating-label">
            <div class="position-relative">
              <b-form-input
                type="password"
                id="input-repeat-password"
                placeholder=" "
                class="floating-label"
                v-model="repeatPassword"
                :state="passwordsMatch"
                trim required
              />
              <label class="floating-label">{{ $gettext('Confirm new password') }}</label>
              <ShowPasswordIcon input-id="input-repeat-password" />
            </div>
            <small class="form-text text-danger" :class="[(repeatPassword.length > 0 && !passwordsMatch) ? 'opacity-100' : 'opacity-0']">
              <font-awesome-icon icon="fa-regular fa-warning" />
              {{ $gettext('Passwords don\'t match') }}
            </small>
          </b-form-group>

          <div style="display: flex; flex-direction:column; padding-top: 0.5rem; width: 100%;">
            <GekkoButton
              type="submit"
              :text="$gettext('Continue')"
              variant="primary"
              :loading="loading"
              :disabled="!formValid"
              class="w-100 text-campton-book mb-3 position-relative"
              size="xl"
            />
            <GekkoButton
              :to="{ name: 'Login' }"
              :text="$gettext('Return to sign in')"
              variant="link"
              class="text-campton-book text-blue"
              size="sm"
            />
          </div>
        </b-form>
      </div>
      <div v-if="showStep === 'saved'" :key="transitionKey">
        <h2 class="text-campton-bold">{{ $gettext('Password changed') }}</h2>
        <p>
          {{ $gettext('Your new password has been saved successfully.') }}, 
        </p>
        <div style="display: flex; flex-direction:column; padding-top: 0.5rem; width: 100%;">
          <GekkoButton
            :to="{ name: 'Login' }"
            :text="$gettext('Return to sign in')"
            variant="primary"
            :loading="loading"
            class="w-100 text-campton-book mb-3 position-relative"
            size="xl"
          />
        </div>
      </div>
      <div v-if="showStep === 'error'" :key="transitionKey">
        <p class="text-center" style="font-size: 24px;">
          <font-awesome-icon icon="fa-regular fa-warning" />
        </p>
        <p class="text-center m-0">
          {{ $gettext('Your password reset request couldn\'t be processed. Make sure you are following the link we sent to your email address.') }}
        </p>
      </div>

    </transition>

  </div>
</template>

<script>
import { mapActions } from "vuex"

import GekkoButton from "@/components/GekkoButton"
import ShowPasswordIcon from "@/components/ui/ShowPasswordIcon"
import PasswordStrengthHint from "@/components/ui/PasswordStrengthHint"

export default {
  name: 'ResetPasswordForm',
  components: {
    GekkoButton,
    ShowPasswordIcon,
    PasswordStrengthHint
  },
  data () {
    return {
      password: '',
      repeatPassword: '',
      requestSent: false,
      transitionKey: 0,
      loading: false,
      passwordChanged: false,
      passwordChangeError: false,
      passwordScore: 0,
      passwordTouch: false
    }
  },
  computed: {
    showStep () {
      let step = 'form'
      if (this.requestToken && !this.requestSent) {
        step = 'form'
      } else if (this.passwordChanged) {
        step = 'saved'
      } else {
        step = 'error'
      }
      return step
    },
    requestToken () {
      return this.$route.query.token
    },
    passwordsMatch () {
      return this.password === this.repeatPassword
    },
    formValid () {
      return this.password.length > 5 && this.passwordsMatch
    },
    passwordState () {
      return (this.passwordScore >= 1)
    },
    showPasswordHint () {
      return (this.password.length > 0)
    },
  },
  created () {
  },
  mounted () {
  },
  methods: {
    ...mapActions({ 
      resetPassword: "auth/resetPassword"
    }),
    saveNewPassword () {
      if (!this.formValid) {
        return false
      }
      this.loading = true
      this.requestSent = true
      this.transitionKey++

      this.resetPassword({
        token: this.requestToken,
        password: this.password
      }).then((response) => {
        this.passwordChanged = true
        this.passwordChangeError = false
      }).catch((err) => {
        console.log('ResetPasswordForm.vue::saveNewPassword() -> ERROR', err)
        this.passwordChangeError = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>